import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IFireDepartmentBcTurnover } from "../../interfaces/firedepartment-bc-turnover/firedepartmentBcTurnover";
import { IPicklistValuesData } from "../../interfaces/administration/picklistValuesData";
import { ICarryoverComments } from "../../interfaces/firedepartment-bc-turnover/firedepartmentCarryoverComments";
import { FireDepartmentsBcTurnoversService } from "../../services/firedepartments/fireDepartmentsBcTurnovers.service";
import { ILoggedUserData } from "../../interfaces/common/loggedUserData";
import { LoggedUserService } from "../../services/common/logged-user.service";

@Component({
  selector: "app-carryover-comments-edit",
  templateUrl: "./carryover-comments-edit.component.html",
  styles: [
    `
      .button-container {
        display: flex !important;
        justify-content: space-between !important;
        margin: 10px 0px 0px 0px;
      }
    `,
  ],
})
export class CaryoverCommentsEditComponent implements OnInit {
  // Input to receive data from parent component if needed
  @Input() bcTurnover: IFireDepartmentBcTurnover;
  @Input() carryoverComments: ICarryoverComments;
  @Input() crewFieldId: number;
  @Input() shiftFieldId: number;

  // Output events to communicate with parent
  @Output() saved = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<void>();

  carryoverForm: FormGroup;
  dateAdded: Date = new Date();
  addedBy: string = "";
  validationMessages: string[] = [];
  today: Date = new Date();

  selectedShift: IPicklistValuesData;
  selectedCrew: IPicklistValuesData;

  isLoading: boolean = true;
  currentUser: ILoggedUserData;

  constructor(
    private fb: FormBuilder,
    private fireDepartmentsBcTurnoversService: FireDepartmentsBcTurnoversService,
    private loggedUserService: LoggedUserService
  ) {
    this.isLoading = true;
    this.createForm();
  }

  ngOnInit(): void {
    if (this.carryoverComments) {
      this.carryoverForm.patchValue({
        crew: this.getSelectedPicklistField(this.crewFieldId)?.id,
        shift: this.getSelectedPicklistField(this.shiftFieldId)?.id,
        comments: this.carryoverComments?.comments,
        id: this.carryoverComments?.id,
      });
      this.loggedUserService.getLoggedUserData().subscribe((user) => {
        this.currentUser = user;
        this.addedBy = `${user?.firstName} ${user?.lastName}`;
      });
      this.isLoading = false;
    }
  }

  createForm(): void {
    this.carryoverForm = this.fb.group({
      crew: ["-1"],
      shift: ["-1"],
      comments: ["", Validators.required],
      id: [0],
    });
  }

  getSelectedPicklistField(fieldId: number) {
    let selectedPicklistValue: IPicklistValuesData =
      this.carryoverComments?.picklistValues.find(
        (x) => x.picklistFieldId === fieldId
      );

    return selectedPicklistValue;
  }

  // Note: Fixed the form name discrepancy from the HTML
  get turnoverForm(): FormGroup {
    return this.carryoverForm;
  }

  onCrewSelected(crew: IPicklistValuesData): void {
    this.selectedCrew = crew;
  }

  onShiftSelected(shift: IPicklistValuesData): void {
    this.selectedShift = shift;
  }

  submit(): void {
    this.validationMessages = [];
    if (this.carryoverForm.get("comments").value === "") {
      this.validationMessages.push("Comments are required.");
    }

    if (
      this.carryoverForm.get("crew").value === "" ||
      this.carryoverForm.get("crew").value === "-1"
    ) {
      this.validationMessages.push("Crew is required.");
    }

    if (
      this.carryoverForm.get("shift").value === "" ||
      this.carryoverForm.get("shift").value === "-1"
    ) {
      this.validationMessages.push("Shift is required.");
    }

    if (this.validationMessages.length > 0) {
      return;
    }

    if (this.carryoverForm.valid) {
      const data: ICarryoverComments = {
        id: this.carryoverForm.get("id").value,
        dateAdded: this.carryoverComments?.dateAdded
          ? this.carryoverComments.dateAdded
          : this.today,
        createdById: this.carryoverComments?.createdById,
        turnoverId: this.carryoverComments?.turnoverId,
        comments: this.carryoverForm.get("comments").value,
        crewId: this.selectedCrew
          ? this.selectedCrew.id
          : this.carryoverForm.get("crew").value,
        shiftId: this.selectedShift
          ? this.selectedShift.id
          : this.carryoverForm.get("shift").value,
        picklistValues: [
          {
            id: this.selectedCrew
              ? this.selectedCrew.id
              : this.carryoverForm.get("crew").value,
            value: this.selectedCrew ? this.selectedCrew.value : undefined,
            picklistFieldId: this.crewFieldId,
            facilityId: Number(this.currentUser?.facilityId) || 1,
          },
          {
            id: this.selectedShift
              ? this.selectedShift.id
              : this.carryoverForm.get("shift").value,
            value: this.selectedShift ? this.selectedShift.value : undefined,
            picklistFieldId: this.shiftFieldId,
            facilityId: Number(this.currentUser?.facilityId) || 1,
          },
        ],
      };

      this.fireDepartmentsBcTurnoversService
        .updateCarryoverComments(data)
        .subscribe((data) => {
          this.carryoverForm.reset();
          this.saved.emit(data);
        });
    } else {
      // Mark all fields as touched to trigger validation messages
      Object.keys(this.carryoverForm.controls).forEach((key) => {
        this.carryoverForm.get(key)?.markAsTouched();
      });
    }
  }

  cancel(): void {
    this.carryoverForm.reset();
    this.cancelled.emit();
  }
}
